import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import { ChapterListItem } from 'components';
import FlashcardListCard from './FlashcardListCard';
import { sortByIndexOfType } from 'utilities';
import { areListItemsEqual } from 'utilities/sideNavUtils';

const StyledListItem = styled(ListItem)(({ theme }) => ({
  '&.MuiListItem-padding': {
    padding: theme.spacing(1.5, 1.5, 0, 1.5),
    '&:last-of-type': {
      paddingBottom: theme.spacing(1.5),
    },
  },
}));

const arePropsEqual = (prevProps, nextProps) => {
  if (prevProps.isOffline !== nextProps.isOffline) {
    return false;
  }

  return areListItemsEqual(prevProps.children, nextProps.children, [
    'confidenceLevel',
    'isPersisted',
    'isSaved',
    'isSwapped',
    'snippet',
    'userText',
  ]);
};

const FlashcardListItem = memo(({ children, isOffline, deck, ...props }) => {
  const label = deck.userText;
  const deckTitle = (
    <div className="noTranslate">{`${label} (${children.length})`}</div>
  );
  const sortedChildren = sortByIndexOfType(children, 'page');

  return (
    <ChapterListItem
      ariaLabelChapterTitle={label}
      id={`flashcard-deck-${deck.id}`}
      isNavItem={false}
      title={deckTitle}
      {...props}
    >
      {sortedChildren?.map((flashcard) => {
        return (
          <StyledListItem key={`flashcard-${flashcard.id}`}>
            <FlashcardListCard contentItem={flashcard} />
          </StyledListItem>
        );
      })}
    </ChapterListItem>
  );
}, arePropsEqual);

FlashcardListItem.propTypes = {
  children: PropTypes.array.isRequired,
  isOffline: PropTypes.bool,
  deck: PropTypes.object.isRequired,
};

export default FlashcardListItem;
